module.exports = __webpack_public_path__ + "static/media/image_4.eabb6218.png";